module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":{"complement":"Homepage","inner":"AppMakers","separator":"|"}},"title":"AppMakers","button":"Documentation","choices":{"none":"Pasirinkite","new":"Naujas užsakymas","update":"Užsakymo pildymas"}}}')
  delete Component.options._Ctor
}
